// eslint-disable-next-line @typescript-eslint/ban-types
export const isObject = (value) => value !== null && typeof value === 'object';
//# sourceMappingURL=is.js.map